import angular from 'angular';
import PasswordResetService from './passwordResetService.service';

let passwordResetServiceModule = angular.module('passwordResetService', []).service('passwordResetService', PasswordResetService);

export default passwordResetServiceModule;



// WEBPACK FOOTER //
// ./app/common/passwordResetService/passwordResetService.js